import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  display: flex;
  flex-shrink: 0;
  cursor: pointer;
`;
